import process from 'process';
import React from 'react';
import { buildTargetingArguments } from '../../common/helpers/ads/AdsHelper';
import AdSlot from './AdSlot';
import { HalfPageAdsWrapper, HalfPageAdsItem } from './HalfPageAds.style';
import { PostProject } from '../../queries/contentPage/postDetail';

interface HalfPageAdsProps {
  project?: PostProject;
  adUnit?: string;
  sect?: string | string[];
  subSect?: string;
  articleId?: string | number | null;
  adContainerHeight?: number;
}

const HalfPageAds: React.FC<HalfPageAdsProps> = ({
  project = {},
  adUnit = '',
  sect = [''],
  subSect = '',
  articleId = null,
  adContainerHeight = 0,
}) => {
  const targetingArguments = buildTargetingArguments(project);

  return (
    <HalfPageAdsWrapper adContainerHeight={adContainerHeight}>
      {(process.browser || process.env.browser) && (
        <HalfPageAdsItem>
          <AdSlot
            adUnit={adUnit}
            sizes={[[300, 600]]}
            targetingArguments={{
              ...targetingArguments,
              sect,
              subSect,
              lang: 'th',
              articleid: articleId,
            }}
          />
        </HalfPageAdsItem>
      )}
    </HalfPageAdsWrapper>
  );
};

export default HalfPageAds;
